const resumeTokenKey = 'resumeToken'

export const getResumeTokenFromHash = (): string | undefined => {
  if (!window.location.hash) {
    return undefined
  }

  const queryFragment = window.location.hash.substring(1)

  const parameters = queryFragment.split(',').reduce((map, parameter) => {
    const keyValue = parameter.split('=')

    map.set(keyValue[0], decodeURIComponent(keyValue[1]))

    return map
  }, new Map<string, string>())

  return parameters.get(resumeTokenKey)
}

export const resumeTokenToHash = (resumeToken: string): string => {
  return `#${resumeTokenKey}=${encodeURIComponent(resumeToken)}`
}

export const storeResumeToken = (resumeToken: string) => {
  localStorage.setItem(resumeTokenKey, resumeToken)
}

export const getResumeToken = (): string | undefined => {
  const localResumeToken = localStorage.getItem(resumeTokenKey)

  if (localResumeToken) {
    return localResumeToken
  }

  return getResumeTokenFromHash()
}
